const _getCategories = () => {
    const categoriesSize = [
        { id: 1, name: 'instagram-post', size: '1080x1080' },
        { id: 2, name: 'popular-farsi', size: '1080x1080' },
        { id: 3, name: 'Instagram Stories', size: '1080x1920' },
        { id: 4, name: 'Large rectangle AD', size: '336x280' },
        { id: 5, name: 'Leaderboard AD', size: '728x90' },
        { id: 6, name: 'Wide skyscraper AD', size: '160x600' },
        { id: 7, name: 'Medium rectangle  AD', size: '300x250' },
        { id: 8, name: 'popular instagram post', size: '1080x1080' },
        { id: 9, name: 'facebook cover', size: '2050x780' },
        { id: 10, name: 'twitter post', size: '1024x512' },
        { id: 11, name: 'twitter Cover', size: '1500x500' },
        { id: 12, name: 'Whatsapp Story', size: '1080x1920' },
        { id: 13, name: 'bdok Banner 1', size: '1140x370' },
        { id: 14, name: 'bdok Banner 2', size: '1140x170' },
        { id: 15, name: 'bdok Banner 3', size: '655x170' },
        { id: 16, name: 'bdok Banner 4', size: '560x170' },
        { id: 17, name: 'bdok Banner 5', size: '465x170' },
        { id: 18, name: 'bdok Banner 6', size: '360x170' },
        { id: 19, name: 'Power Point', size: '1920x1080' },
        { id: 20, name: 'Business Card', size: '1050x600' },
        { id: 21, name: 'Resume', size: '2480x3508' },
    ]
    return categoriesSize;
}

export { _getCategories }